import OwnableIcon from '@Components/Common/Icons/OwnableIcon';
import { observer } from 'mobx-react-lite';
import type { FC } from 'react';
import React from 'react';
import { Platform, TouchableWithoutFeedback } from 'react-native';
import styled, { css } from 'styled-components/native';

import OwnableTheme from '../../assets/OwnableTheme';
import useControlPanelPresenter from './presenter';

const StyledContainer = styled.View`
  display: flex;
  flex-direction: row;
  height: 0;
  width: 100%;
  position: absolute;
`;

// this is the floating circular icon container that used to be top-left,
// but currently is replaced by 'DEMO' text. leaving here in case it wants
// to come back as a clickable with a new logo icon at some point..

// const StyledOwnableIconContainer = styled.View<{ borderRadius: number }>`
//   position: absolute;
//   top: 20px;
//   left: 20px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   width: 46px;
//   height: 46px;
//   filter: drop-shadow(0px 0px 20px #9b9b9b);
//   border-radius: ${({ borderRadius }) => `${borderRadius}px`};
//   background-color: ${OwnableTheme.colors.amaranth};
//   ${Platform.OS === 'web' &&
//   css`
//     cursor: pointer;
//   `};
//   margin-right: 15px;
// `;

const StyledDemoText = styled.View<{ borderRadius: number }>`
  position: absolute;
  top: 20px;
  left: 40px;
  display: flex;
  align-items: center;
  font-family: ${OwnableTheme.fonts.gilroy.bold};
  font-size: ${OwnableTheme.fontSizes.xxl};
  color: ${OwnableTheme.colors.black};
  justify-content: left;
  filter: drop-shadow(0px 0px 20px #9b9b9b);
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
  margin-right: 15px;
`;

const ControlPanelBigBrowse: FC = observer(() => {
  const { handleOwnableLogoPress, showControlPanel } =
    useControlPanelPresenter();

  if (!showControlPanel) {
    return null;
  }

  return (
    <StyledContainer>
      <TouchableWithoutFeedback onPress={handleOwnableLogoPress}>
        <StyledDemoText borderRadius={100}>DEMO</StyledDemoText>
      </TouchableWithoutFeedback>
    </StyledContainer>
  );
});

export default ControlPanelBigBrowse;
